<div class="settings-box__text">
  Щоб підключити персонального менеджера, підпишіть договір про надання послуг
</div>